import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgGezinMetKinderen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#B3E9B1"
      d="M27.42 20a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
    />
    <path
      fill="#B3E9B1"
      fillRule="evenodd"
      d="M27.42 20a6 6 0 0 1 6 6v8h-12v-8a6 6 0 0 1 6-6"
      clipRule="evenodd"
    />
    <path
      fill="#B3E9B1"
      d="M12.58 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
    />
    <path
      fill="#B3E9B1"
      fillRule="evenodd"
      d="M12.58 18a6 6 0 0 1 6 6v10h-12V24a6 6 0 0 1 6-6"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M24.437 15.053a3.021 3.021 0 1 0 6.006 0l.994-.106a4.02 4.02 0 1 1-7.994 0zM12.017 12.947a3.02 3.02 0 0 0 6.006 0l.994.106a4.02 4.02 0 0 1-7.994 0z"
      clipRule="evenodd"
    />
    <path
      fill="#60D15D"
      d="M24.79 28a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
    />
    <path
      fill="#60D15D"
      fillRule="evenodd"
      d="M28.79 32a4 4 0 1 0-8 0v2h8zM19.09 30a4 4 0 0 0-8 0v4h8z"
      clipRule="evenodd"
    />
    <path
      fill="#60D15D"
      d="M15.09 26a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgGezinMetKinderen);

export default ForwardRef;
